var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/Recovery.tsx";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const Recovery = ({
  color = '#353B60',
  ...other
}) => /*#__PURE__*/_jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...other,
  children: [/*#__PURE__*/_jsx("g", {
    clipPath: "url(#clip0_306_92589)",
    children: /*#__PURE__*/_jsx("path", {
      d: "M13.2586 3.0001C8.16857 2.8601 3.99857 6.9501 3.99857 12.0001H2.20857C1.75857 12.0001 1.53857 12.5401 1.85857 12.8501L4.64857 15.6501C4.84857 15.8501 5.15857 15.8501 5.35857 15.6501L8.14857 12.8501C8.45857 12.5401 8.23857 12.0001 7.78857 12.0001H5.99857C5.99857 8.1001 9.17857 4.9501 13.0986 5.0001C16.8186 5.0501 19.9486 8.1801 19.9986 11.9001C20.0486 15.8101 16.8986 19.0001 12.9986 19.0001C11.3886 19.0001 9.89857 18.4501 8.71857 17.5201C8.31857 17.2101 7.75857 17.2401 7.39857 17.6001C6.97857 18.0201 7.00857 18.7301 7.47857 19.0901C8.99857 20.2901 10.9086 21.0001 12.9986 21.0001C18.0486 21.0001 22.1386 16.8301 21.9986 11.7401C21.8686 7.0501 17.9486 3.1301 13.2586 3.0001ZM12.7486 8.0001C12.3386 8.0001 11.9986 8.3401 11.9986 8.7501V12.4301C11.9986 12.7801 12.1886 13.1101 12.4886 13.2901L15.6086 15.1401C15.9686 15.3501 16.4286 15.2301 16.6386 14.8801C16.8486 14.5201 16.7286 14.0601 16.3786 13.8501L13.4986 12.1401V8.7401C13.4986 8.3401 13.1586 8.0001 12.7486 8.0001Z",
      fill: color
    })
  }), /*#__PURE__*/_jsx("defs", {
    children: /*#__PURE__*/_jsx("clipPath", {
      id: "clip0_306_92589",
      children: /*#__PURE__*/_jsx("rect", {
        width: "24",
        height: "24",
        fill: "white"
      })
    })
  })]
});